/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivClearanceControllerGetParamsGen,
  MrfiktivClearanceViewModelGen,
  MrfiktivCreateClearanceDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivUpdateClearanceDtoGen,
  MrfiktivUpdateClearanceStatusDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Clearance<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags clearance
   * @name ClearanceControllerCreate
   * @summary (Clearance - CREATE) Create a Clearance
   * @request POST:/partner/{partnerId}/clearance
   * @secure
   * @response `201` `MrfiktivClearanceViewModelGen` The created clearance
   */
  clearanceControllerCreate = (partnerId: string, data: MrfiktivCreateClearanceDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivClearanceViewModelGen, any>({
      path: `/partner/${partnerId}/clearance`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags clearance
   * @name ClearanceControllerGet
   * @summary (Clearance - READ) Get all Clearances
   * @request GET:/partner/{partnerId}/clearance
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivClearanceViewModelGen)[] })`
   */
  clearanceControllerGet = (
    { partnerId, ...query }: MrfiktivClearanceControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivClearanceViewModelGen[] }, any>({
      path: `/partner/${partnerId}/clearance`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags clearance
   * @name ClearanceControllerGetOne
   * @summary (Clearance - READ) Get a Clearance
   * @request GET:/partner/{partnerId}/clearance/{clearanceId}
   * @secure
   * @response `200` `MrfiktivClearanceViewModelGen` The clearance
   */
  clearanceControllerGetOne = (partnerId: string, clearanceId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivClearanceViewModelGen, any>({
      path: `/partner/${partnerId}/clearance/${clearanceId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags clearance
   * @name ClearanceControllerUpdate
   * @summary (Clearance - UPDATE) Update a Clearance
   * @request PATCH:/partner/{partnerId}/clearance/{clearanceId}
   * @secure
   * @response `200` `MrfiktivClearanceViewModelGen` The updated clearance
   */
  clearanceControllerUpdate = (
    partnerId: string,
    clearanceId: string,
    data: MrfiktivUpdateClearanceDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivClearanceViewModelGen, any>({
      path: `/partner/${partnerId}/clearance/${clearanceId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags clearance
   * @name ClearanceControllerDelete
   * @summary (Clearance - DELETE) Delete a Clearance
   * @request DELETE:/partner/{partnerId}/clearance/{clearanceId}
   * @secure
   * @response `200` `MrfiktivClearanceViewModelGen` The deleted clearance
   */
  clearanceControllerDelete = (partnerId: string, clearanceId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivClearanceViewModelGen, any>({
      path: `/partner/${partnerId}/clearance/${clearanceId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags clearance
   * @name ClearanceControllerSetIsCleared
   * @summary (Clearance - set is cleared) Update a Clearance
   * @request PATCH:/partner/{partnerId}/clearance/{clearanceId}/isCleared
   * @secure
   * @response `200` `MrfiktivClearanceViewModelGen` The updated clearance
   */
  clearanceControllerSetIsCleared = (partnerId: string, clearanceId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivClearanceViewModelGen, any>({
      path: `/partner/${partnerId}/clearance/${clearanceId}/isCleared`,
      method: "PATCH",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags clearance
   * @name ClearanceControllerUpdateStatus
   * @summary (Clearance - UPDATE) Update status of a clearance
   * @request PATCH:/partner/{partnerId}/clearance/{clearanceId}/status
   * @secure
   * @response `200` `MrfiktivClearanceViewModelGen` The updated clearance
   */
  clearanceControllerUpdateStatus = (
    partnerId: string,
    clearanceId: string,
    data: MrfiktivUpdateClearanceStatusDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivClearanceViewModelGen, any>({
      path: `/partner/${partnerId}/clearance/${clearanceId}/status`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
